module.exports = __webpack_public_path__ + "img/runner.9d466199.png";